import { render, staticRenderFns } from "./AreaStock.vue?vue&type=template&id=2416490e&scoped=true"
import script from "./AreaStock.vue?vue&type=script&lang=js"
export * from "./AreaStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2416490e",
  null
  
)

export default component.exports